import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/axios';

const AuthContext = createContext();

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    if (token && userData) {
      if (isTokenExpired(token)) {
        logout();
      } else {
        setUser(JSON.parse(userData));
      }
    }
    setAuthLoading(false);
  }, []);

  // Her 5 dakikada bir token kontrolü
  useEffect(() => {
    const interval = setInterval(() => {
      const token = localStorage.getItem('token');
      if (token && isTokenExpired(token)) {
        logout();
        window.location.href = '/giris';
      }
    }, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  // API 401 hatalarında otomatik logout
  useEffect(() => {
    const interceptor = api.interceptors.response.use(
      res => res,
      err => {
        if (err.response?.status === 401) {
          logout();
          window.location.href = '/giris';
        }
        return Promise.reject(err);
      }
    );
    return () => api.interceptors.response.eject(interceptor);
  }, []);

  const login = async (username, password) => {
    const res = await api.post('/auth/login', { username, password });
    const loggedInUser = {
      ...res.data.user,
      phone: res.data.user.phone || ''
    };
    localStorage.setItem('token', res.data.token);
    localStorage.setItem('user', JSON.stringify(loggedInUser));
    setUser(loggedInUser);
    return loggedInUser;
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, loading: authLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
